import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { orderTrackingCrossSelling, orderTrackingForbidden } from 'src/app/core/constants/routes';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { devLog } from 'src/app/core/utils/generic-utils';
import { accountHasAddon } from 'src/app/core/utils/global-utils';

@Injectable({
  providedIn: 'root',
})
export class OrderTrackingGuardService {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const { company } = await this.userDataService.getUserAndCompany();
      const companyHasAddon = accountHasAddon('order-tracking', company?.serviceAddons ?? []);

      if (!companyHasAddon) {
        this.router.navigateByUrl(orderTrackingCrossSelling);
        return false;
      }

      if (this.permissionsService.hasAddonAccess('order-tracking')) {
        return true;
      }

      this.router.navigateByUrl(orderTrackingForbidden);
    } catch (err) {
      devLog(err);
    }

    return false;
  }
}
